﻿{
    "ai-apps": {
        "tenantPromptMenu": "Leietaker-prompt",
        "mcpServersMenu": "MCP-servere",
        "menu": "App Builder",
        "list": {
            "title": "Apper",
            "name": "App-navn",
            "createApp": "Opprett ny app",
            "deletedSuccessfully": "Applikasjonen ble slettet",
            "noAppsFound": "Ingen applikasjoner funnet",
            "noPublishedVersion": "Ingen publisert versjon",
            "publishedBy": "av {name}",
            "versionsCount": "• {count} versjoner",
            "updatedAt": "Oppdatert {time}",
            "startApp": "Start app",
            "runPublishedVersion": "Kjør publisert versjon",
            "editApp": "Rediger siste versjon",
            "continueEditingVersion": "Fortsett å redigere v{version}",
            "copyApp": "Kopier app",
            "copyAppSubtitle": "Opprett en kopi av denne appen",
            "deleteApp": "Slett app",
            "deleteAppSubtitle": "Slett denne appen permanent",
            "rowsPerPage": "Rader per side",
            "showAll": "Alle"
        },
        "nameAndDescription": "Generelt",
        "buildTitle": "AI-assistent",
        "dropSession": "Forkast",
        "dropSessionConfirmation": "Er du sikker på at du vil slette gjeldende byggeøkt og forkaste alle genererte filer og samtale?",
        "saveSession": "Lagre",
        "saveAndContinue": "Lagre og fortsett å bygge",
        "saveAndExit": "Lagre og avslutt byggmodus",
        "applySessionConfirmation": "Er du sikker på at du vil lagre resultatene fra gjeldende byggeøkt?",
        "sessionConflict": "En annen bruker redigerer for øyeblikket denne versjonen",
        "sessionConflictDetail": "Kun én bruker kan jobbe på en versjon om gangen. Vennligst prøv igjen senere.",
        "sessionConflictSuggestion": "Du kan velge en annen versjon eller vente til den nåværende økten er fullført.",
        "sessionStartError": "Kunne ikke starte byggeøkt",
        "undoLastPrompt": "Angre siste prompten",
        "undoLastPromptFailed": "Kunne ikke angre siste prompten",
        "stopGenerating": "Stopp genereringen",
        "stopGeneratingFailed": "Kunne ikke stoppe genereringen",
        "cancelled": "Avbrutt",
        "undone": "Angret",
        "applicationLabels": "Applikasjonsetiketter",
        "labels": "Etiketter",
        "description": "Beskrivelse",
        "deleteConfirmation": "Er du sikker på at du vil slette følgende applikasjon: {name}",
        "copy": "Kopier",
        "copyApplication": "Kopier applikasjon",
        "copyOfName": "Kopi av {name}",
        "copyFromVersion": "Kopier fra versjon",
        "applicationCopied": "Applikasjonen ble kopiert",
        "selectTables": "Tabeller",
        "name": "Navn",
        "connection": "Tilkobling",
        "vinceAi": "Vince AI",
        "usage": "Bruk",
        "tenantUsageTitle": "Bruk for AI-apper",
        "applicationUsageTitle": "Bruk for {name}",
        "versionUsageTitle": "Bruk for versjon {version}",
        "usageLoadError": "Bruksdata kunne ikke lastes.",
        "vinceAiMcpUnsupported": "Vince AI støtter for øyeblikket ikke MCP-serverressurser. Velg en tenant-tilkobling eller fjern MCP-serverne.",
        "selectWorkflows": "Arbeidsflyter",
        "summary": "Sammendrag",
        "publishedColumn": "Publisert",
        "stateHeader": "Status",
        "createdBy": "Opprettet av",
        "modifiedBy": "Endret av",
        "created": "Opprettet av {name} den {date}",
        "newApplication": "Opprett ny applikasjon",
        "customTablesSelected": "{selectedCount} egendefinerte tabeller valgt.",
        "workflowsSelected": "{selectedCount} arbeidsflyter valgt.",
        "selectMcpServers": "MCP-servere",
        "mcpServersSelected": "{selectedCount} MCP-servere valgt.",
        "summaryHeader": "Applikasjonssammendrag",
        "resourceAliases": "Overstyr ressursaliaser",
        "absentResource": "Ressurs ikke funnet",
        "customAlias": "Alias",
        "state": {
            "DRAFT": "Utkast",
            "PUBLISHED": "Publisert",
            "ARCHIVED": "Arkivert"
        },
        "run": "Start",
        "currentVersion": "Versjon",
        "publishedVersionTooltip": "Publisert versjon - av {name}",
        "createdVersions": "Opprettede versjoner",
        "backToList": "Tilbake til listen",
        "back": "Tilbake",
        "Version": "Versjon",
        "archive": "Arkiver",
        "publish": "Publiser",
        "selectedVersion": "Valgt versjon",
        "ver": "ver. ",
        "startBuildSession": "Bygg",
        "editVersionInfo": "Notater",
        "createNewVersion": "Opprett ny versjon",
        "archiveVersion": "Arkiver",
        "resources": "Ressurser",
        "viewResources": "Ressurser",
        "versionResourcesLabel": "Ressurser for ny versjon",
        "versionRolesLabel": "Roller for ny versjon",
        "copyVersionRoles": "Kopier roller fra versjon {versionNumber}",
        "specifyNewRoles": "Opprett nye roller",
        "specifyRolesAssignments": "Tilordne prinsipal fra bunnen av",
        "copyRolesAssignments": "Kopier rolletilordninger fra versjon {versionNumber}",
        "specifyNewResources": "Spesifiser nye ressurser",
        "versionAssets": "Ressurser for ny versjon",
        "copyVersionResources": "Kopier ressurser fra versjon {versionNumber}",
        "copyVersionAssets": "Kopier ressurser fra versjon {versionNumber}",
        "generateFromScratch": "Generer fra bunnen av",
        "resourcesNamesAreNotUnique": "Ressursnavn må være unike",
        "editApplicationInfo": "Rediger info",
        "publishVersion": "Publiser",
        "updateVersionDescription": "Oppdater beskrivelse",
        "editVersionTitle": "Legg til notat",
        "updateVersionNotes": "Oppdater notater",
        "archiveVersionTitle": "Arkiver versjon",
        "publishVersionTitle": "Publiser versjon",
        "setAsDraftVersionTitle": "Konverter til utkast",
        "newVersion": "Ny versjon",
        "versionResources": "Ressurser tilgjengelig for applikasjon",
        "resourceNaming": "Ressursnavn",
        "resourcesUpdated": "Ressurser oppdatert",
        "changelog": "Versjonshistorikk",
        "changelogTitle": "Applikasjonsversjoner",
        "versionUpdated": "Versjonsinformasjon oppdatert",
        "versionCreated": "Ny versjon opprettet",
        "isFavourite": "Din favorittapp. Klikk for å fjerne fra favoritter",
        "isNotFavourite": "Klikk for å merke som favorittapp",
        "copiedVersionDescription": "Beskrivelse for ny versjon",
        "messageSendFailed": "Kunne ikke sende melding. Vennligst prøv igjen.",
        "messageError": "Feil",
        "waitingForResponse": "Venter på svar...",
        "typeYourMessage": "Skriv din melding...",
        "loadingConversation": "Laster samtale...",
        "loadingVersionInfo": "Laster versjonsinformasjon...",
        "maxImagesReached": "Maksimalt {max} bilder tillatt per melding",
        "invalidImageType": "Ugyldig bildetype: {type}. Tillatte typer: PNG, JPEG, GIF, WebP",
        "imageTooLarge": "Bildestørrelsen overskrider {max}KB grensen",
        "imageUploadFailed": "Kunne ikke laste opp bilde: {filename}",
        "clickBuildToBuild": "Klikk bygg for å starte bygging av applikasjon...",
        "unsavedWorkAlert": "Du har ulagret arbeid. Trykk Lagre for å lagre fremdriften din.",
        "unsavedWorkLeaveMessage": "Du har en aktiv byggeøkt med ulagret arbeid. Hvis du forlater siden, vil fremdriften din gå tapt. Er du sikker på at du vil fortsette?",
        "providedAppsCanBeRunDirectly": "Leverte apper kan kjøres direkte fra listen.",
        "labelsFilterSelected": "etiketter valgt",
        "users": "Brukere",
        "usersFilterSelected": "brukere valgt",
        "createdOrEditedBy": "Opprettet eller endret av",
        "preview": {
            "appBridgeLogs": "Brologg {logsCount}",
            "noPreviewAvailable": "Ingen forhåndsvisning tilgjengelig",
            "askAiToGenerate": "Ingenting å vise ennå, legg til en forespørsel for å begynne å bygge",
            "compilationFailed": "Kompilering mislyktes",
            "compiling": "Kompilerer...",
            "loading": "Laster forhåndsvisning...",
            "loadFailed": "Kunne ikke laste forhåndsvisning",
            "clearLogs": "Tøm logger",
            "invocationLogs": "App-bro-logger"
        },
        "invocationAction": {
            "REQUEST_RECEIVED": "Forespørsel fra app: ",
            "RESPONSE_RETURNED": "Svar til app ",
            "ERROR": "Det oppstod en feil ",
            "INIT": "Bro initialisert"
        },
        "startingApplication": "Starter applikasjon. Vennligst vent...",
        "providedSourceUrl": "Indeks-URL for levert app",
        "applicationType": {
            "GENERATED": "Generert",
            "PROVIDED": "Levert"
        },
        "applicationTypeLabel": "Applikasjonstype",
        "minimize": "Minimer",
        "toggleFullScreen": "Fullskjerm",
        "resource": {
            "app": "App"
        },
        "seconds": "s",
        "noMessagesYet": "Ingen meldinger ennå",
        "generatedAssets": "Genererte ressurser",
        "assetsListTitle": "Ressursliste",
        "selectAsset": "Velg ressurs for å se detaljer",
        "showAssets": "Ressurser",
        "noStartUrlProvided": "Kan ikke bestemme start-URL for applikasjon",
        "refresh": "Oppdater",
        "cannotEditInfoOfAppWithBuildSession": "Kan ikke redigere versjonsinformasjon med aktiv byggeøkt",
        "cannotShowOfAppWithBuildSession": "Kan ikke vise ressurser med aktiv byggeøkt - ressurser vil være tilgjengelig etter at byggeøkten er fullført",
        "cannotArchiveVersionWithBuildSession": "Kan ikke arkivere versjon med aktiv byggeøkt. Bruk eller forkast gjeldende byggeøkt først",
        "cannotPublishVersionWithBuildSession": "Kan ikke publisere versjon med aktiv byggeøkt. Bruk eller forkast gjeldende byggeøkt først",
        "cannotEditResourcesWithBuildSession": "Med aktiv byggeøkt er det kun mulig å se ressurser",
        "cannotEditRolesWithBuildSession": "Kan ikke redigere in-app roller med aktiv byggeøkt. Bruk eller forkast gjeldende byggeøkt først",
        "tenantPrompt": {
            "title": "Leietaker-prompt",
            "subtitle": "Prompt som automatisk vil bli lagt til som en del av systemprompt til alle samtaler med din AI-assistent."
        },
        "principalType": {
            "USER": "Bruker",
            "ROLE": "Rolle"
        },
        "selectUsers": "Velg brukere",
        "assignments": "In-app rolletilordninger: ",
        "simulateRoles": "Simuler roller",
        "roleNotAssigned": "Rollen har ingen tildelte prinsipal",
        "addAssignments": "Legg til tilordninger",
        "rolesSelected": "{selectedCount} roller valgt.",
        "usersSelected": "{selectedCount} brukere valgt.",
        "selectRoles": "Velg roller",
        "rolesMenu": "In-app roller",
        "rolesListTitle": "Roller",
        "deleteRoleSuccess": "In-app rolle slettet",
        "editRole": "Rediger in-app rolle",
        "roleName": "Rollenavn/identifikator",
        "roleNameHint": "Prøv å bruke kort og beskrivende navn",
        "dangerToChangeRole": "Endring av rollenavn/identifikator kan ødelegge eksisterende applikasjon. Endre kun hvis du er sikker på at applikasjonen ikke bruker denne rollen.",
        "deleteRoleConfirmation": "Er du helt sikker på at du vil slette rollen: {role}? Alle rolletilordninger vil også bli fjernet og deler av applikasjonen kan bli ubrukelig uten den.",
        "selectRole": "Velg rolle for å se tilordninger",
        "selectSession": "Velg byggeøkt for å se prompt",
        "sessionsTitle": "Byggeøkter",
        "noBuildSessions": "Ingen fullførte byggeøkter ennå",
        "showBuildPrompt": "Bygg prompt",
        "feedbackMenu": "Tilbakemeldinger",
        "feedbackTitle": "Tilbakemeldinger for applikasjonen",
        "showRead": "Vis leste",
        "thisVersionOnly": "Kun denne versjonen",
        "noFeedback": "Ingen tilbakemeldinger ennå",
        "markAsRead": "Merk som lest",
        "feedbackMarkedRead": "Tilbakemelding merket som lest",
        "read": "Lest",
        "feedbackSubmitted": "Av {name} den {date}",
        "feedbackComment": "Tilbakemelding",
        "feedbackBy": "Sendt av",
        "feedbackDate": "Dato",
        "feedbackStatus": "Status",
        "mcpServers": {
            "title": "MCP-servere",
            "create": "Legg til MCP-server",
            "createTitle": "Legg til MCP-server",
            "editTitle": "Rediger MCP-server",
            "name": "Navn",
            "nameHint": "Maskinidentifikator som brukes som koblingsnavn. Må samsvare med tillatt tegnsett.",
            "namePatternError": "Navnet kan bare inneholde bokstaver, tall, understrek og bindestrek (1-128 tegn).",
            "systemPrompt": "Systemprompt",
            "systemPromptHint": "Valgfritt promptfragment som beskriver serverens verktøy for app-byggerassistenten.",
            "config": "Konfigurasjonsmal",
            "configHint": "JSONata/VinceLiveMorph-mal som må evalueres til et objekt {props}. Eksempel:",
            "configVariables": "Tilgjengelige variabler (direkte og under $context): $authToken, $userId, $email. JSONata-variabler er uten anførselstegn. url må være en ikke-tom streng.",
            "noServersFound": "Ingen MCP-servere konfigurert ennå",
            "deleteConfirmation": "Er du sikker på at du vil slette MCP-serveren: {name}?",
            "deleted": "MCP-server slettet",
            "created": "MCP-server opprettet",
            "updated": "MCP-server oppdatert",
            "testConnection": "Test tilkobling",
            "probeReachable": "Server tilgjengelig",
            "probeNoTools": "Server tilgjengelig, ingen verktøy tilgjengelig",
            "probeFailed": "Tilkobling mislyktes"
        },
        "devicePicker": {
            "deleted": "Enhet slettet",
            "DESKTOP": "Skrivebord",
            "TABLET": "Nettbrett",
            "HANDHELD": "Mobil",
            "addCustom": "Legg til egendefinert",
            "customDefault": "Egendefinert",
            "responsivePreview": "Responsiv forhåndsvisningsmodus",
            "rotate": "Roter visningsport"
        },
        "serviceStatus": {
            "minor": "AI-funksjoner kan være litt tregere enn vanlig.",
            "major": "AI-funksjoner er for øyeblikket forstyrret — forvent trege svar.",
            "critical": "AI-tjenesten er for øyeblikket utilgjengelig."
        }
    }
}
